export default __webpack_public_path__ + "static/media/empty_tabPromo.b3e89f8e.svg";